<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="testimonial-page pt-227 pb-100">
    <Testimonial2Content />
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";
import Testimonial2Content from "../components/OurTeam/Testimonial2Content.vue";

export default defineComponent({
  name: "Testimonial2Page",
  components: {
    MainNavbar,
    MainFooter,
    Testimonial2Content,
  },
});
</script>

<style scoped>
.testimonial-page {
  padding: 100px 20px 20px 20px;
}
</style>
